/* @flow */
import Chat from 'entities/Chat';
import PotentialChatMember from 'entities/PotentialChatMember';
import getMatcher from 'utils/getMatcher';

export const makeConversationFilter = (query: string) => {
  const isMatch = getMatcher(query);
  return (chat: Chat) => !chat.isNew() && isMatch([chat.getQueryKey()]);
};

export const makePeopleFilter = (query: string = '') => {
  const isMatch = getMatcher(query);
  return (pcm: PotentialChatMember) => isMatch([pcm.getQueryKey()]);
};
